import type { ValueAxisScale } from '../TimeSeriesChart.types';
import type { ValueRange } from './ValueRange.types';

function widenAroundCenter({ min, max }: ValueRange, span: number): ValueRange {
  const center = (min + max) / 2;

  return { min: center - span / 2, max: center + span / 2 };
}

function getShiftIntoLimits({ min, max }: ValueRange, lowerLimit: number, upperLimit: number): number {
  if (min < lowerLimit) {
    return lowerLimit - min;
  }

  if (max > upperLimit) {
    return upperLimit - max;
  }

  return 0;
}

function keepWithinLimits(
  range: ValueRange,
  lowerLimit = Number.NEGATIVE_INFINITY,
  upperLimit = Number.POSITIVE_INFINITY
): ValueRange {
  const shift = getShiftIntoLimits(range, lowerLimit, upperLimit);

  return {
    min: Math.max(range.min + shift, lowerLimit),
    max: Math.min(range.max + shift, upperLimit),
  };
}

export function applyValueAxisScale(range: ValueRange, scale: ValueAxisScale | undefined): ValueRange {
  if (!scale) {
    return range;
  }

  const start: ValueRange = { min: scale.forceMin ?? range.min, max: range.max };
  const { minSpan } = scale;

  if (minSpan === undefined || start.max - start.min >= minSpan) {
    return start;
  }

  return keepWithinLimits(widenAroundCenter(start, minSpan), scale.lowerLimit, scale.upperLimit);
}
